/* ============================================================
   VD Real Results — video testimonial
   • Play button swaps the poster for the Shopify-hosted video.
   • Pauses when scrolled out of view or the tab is hidden.
   Vanilla JS, no deps, idempotent, theme-editor aware.
   ============================================================ */
(function () {
  'use strict';

  if (window.__vdRrvLoaded) return;
  window.__vdRrvLoaded = true;

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-vd-rrv]').forEach(function (section) {
      if (section.dataset.vdRrvInit === '1') return;
      section.dataset.vdRrvInit = '1';

      var media = section.querySelector('[data-vd-rrv-media]');
      var video = section.querySelector('[data-vd-rrv-video]');
      var play = section.querySelector('[data-vd-rrv-play]');
      if (!media || !video || !play) return;

      play.addEventListener('click', function () {
        media.classList.add('is-playing');
        video.controls = true;
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
        video.focus({ preventScroll: true });
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.intersectionRatio < 0.5 && !video.paused) video.pause();
          });
        }, { threshold: [0, 0.5] }).observe(media);
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden && !video.paused) video.pause();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
